// src/Activation/Activation.jsx
import React, { useState, Fragment, useEffect } from 'react';
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, Image } from "../AbstractElements";
import logoLight from '../../src/assets/images/login/logo_white.png';
import logoDark from '../../src/assets/images/login/logo_dark.png';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from "react-toastify";
import { IoMdKey } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { useLicense } from '../_helper/LicenseContext';
import { axiosNAKBHOInstance } from '../interceptor/intercetptor-inctence';
import { useLab } from '../_helper/PharmacyProvider';

export default function ActivateLicense() {
    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(false);
    const { licenseStatus, licenseData, isValid, saveLicenseToken, doesLicenseBelongToUser } = useLicense();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { setCurrentLab, currentLab } = useLab()
    const user = JSON.parse(localStorage.getItem("currentLab"))
    // console.log(user)
    // AUTO REDIRECT IF ALREADY VALID
    // useEffect(() => {
    //     if (isValid && licenseData) {
    //         console.log('License already valid → redirecting to dashboard');
    //         toast.success('License already active! Redirecting...');
    //         navigate(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
    //     }
    // }, [isValid, licenseData, navigate]);

    useEffect(() => {
        const checkAndRedirect = async () => {
            if (isValid && licenseData && currentLab?._id) {
                // Verify license belongs to current user
                const belongsToUser = doesLicenseBelongToUser(licenseData, currentLab._id);

                if (belongsToUser) {
                    console.log('License already valid → redirecting to dashboard');
                    toast.success('License already active! Redirecting...');
                    navigate(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
                }
            }
        };

        checkAndRedirect();
    }, [isValid, licenseData, currentLab?._id, navigate]);

    const handleActivate = async () => {
        const inputToken = token.trim();
        if (!inputToken) {
            toast.warning('Please enter your license key');
            return;
        }
        setLoading(true)
        try {
            const payload = {
                licenseKey: inputToken,
                user: {
                    id: user?._id,
                    name: user.contact_person.first_name + " " + user.contact_person.last_name,
                    // type:"laboratory",
                }
            }
            // const response = await axiosNAKBHOInstance.post('https://noorilabs.techtrial.work/api/licenses/activate', payload)
            const response = await axiosNAKBHOInstance.post('https://api.lab.clinicdots.com/api/lab-user/activate-license-key', payload)
            // console.log(response)
            if (response.data.success == true) {
                await saveLicenseToken(response.data.data.data.token);
                localStorage.setItem("licenseKey", inputToken)
                toast.success(response.data.message);
                setTimeout(() => {
                    navigate(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
                    // setLoading(false);
                }, 500);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    const [containerHeight, setContainerHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setContainerHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Helper to format expiry date
    const formatExpiry = () => {
        if (!licenseData?.expiresAt) return null;
        const date = new Date(Number(licenseData.expiresAt));

        return date.toLocaleString("en-GB", {
            timeZone: "UTC",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
        });
    };

    // MESSAGE COMPONENT — RIGHT SIDE CARD
    const renderStatusMessage = () => {
        switch (licenseStatus) {
            case 'expired':
                return (
                    <div className="alert alert-warning mt-4 p-4 border-left-warning">
                        <h5>License Expired</h5>
                        <p className="mb-2">
                            Your license expired on: <strong>{formatExpiry()}</strong>
                        </p>
                        <p className="mb-0">
                            Please contact support or renew your subscription to continue using the application.
                        </p>
                    </div>
                );

            case 'time-tampered':
                return (
                    <div className="alert alert-danger mt-4 p-4 border-left-danger">
                        <h5>Security Alert</h5>
                        <p className="mb-2">
                            <strong>System clock manipulation detected!</strong>
                        </p>
                        <p className="mb-0">
                            Your system date/time was changed to bypass license expiry.<br />
                            Please set the correct date and time to continue.
                        </p>
                    </div>
                );

            case 'invalid':
                return (
                    <div className="alert alert-danger mt-4 p-4">
                        <h5>Invalid License</h5>
                        <p>The license key is invalid, corrupted, or has been tampered with.</p>
                    </div>
                );
            default:
                return null;
        }
    };

    const logoutUser = async () => {
        localStorage.clear();
        localStorage.setItem("authenticated", false);
        setCurrentLab(null);
        navigate(`${process.env.PUBLIC_URL}/login`, { replace: true });
    };

    return (
        <Fragment>
            <div className="login-page">
                <Container fluid={false} style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
                    <div className="card">
                        <Row className="m-0">
                            <Col
                                xs="6"
                                className="b-center bg-size d-none d-md-flex flex-column"
                                style={{
                                    backgroundImage: `url(${require('../assets/images/login/login_left_img.png')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderTopLeftRadius: '15px',
                                    borderBottomLeftRadius: '15px',
                                    // padding: '20px',
                                    color: 'black', // Ensures text is white on the dark background
                                }}
                            >
                                <div style={{ marginLeft: "10%" }}>
                                    <Image
                                        attrImage={{
                                            className: 'login-logo-style',
                                            src: `${logoLight}`,
                                            alt: 'CLINICDOTS Logo',
                                        }}
                                    />
                                    <h3 style={{ fontWeight: 'bold', marginBottom: '0px', letterSpacing: '2px' }}>CLINICDOTS</h3>
                                    <h3 style={{ fontWeight: 'bold', marginBottom: '20px', letterSpacing: '3px' }}>LABORATORY</h3>
                                    <span>{t("Innovating Healthcare for India.")}</span>
                                </div>
                            </Col>

                            <Col xs="12" md="6"
                                style={{
                                    backgroundImage: `url(${require('../assets/images/login/login_right_img.png')})`,
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                    borderTopLeftRadius: '15px',
                                    borderBottomLeftRadius: '15px',
                                    minHeight: `${containerHeight * 0.94}px`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                {/* STATUS MESSAGES */}
                                {renderStatusMessage()}
                                <div className='login-card' style={{ flex: '1' }}>
                                    <div className="login-form-responsive">
                                        <Form className="theme-form login-form">
                                            {/* This image will only be visible on mobile screens */}
                                            <Image
                                                attrImage={{
                                                    className: 'login-dark-logo-style d-block d-md-none',
                                                    src: `${logoDark}`,
                                                    alt: 'CLINICDOTS Logo',
                                                }}
                                            />
                                            <H4><strong className="mb-3">{t("Activate Your Application")}</strong></H4>
                                            {/* ACTIVATION FORM */}
                                            {['none', 'invalid', 'expired', 'time-tampered'].includes(licenseStatus) && (
                                                <>
                                                    <P>{t("Please enter the license key provided to you.")}</P>

                                                    <FormGroup className="position-relative">
                                                        {/* <Label className="col-form-label">{t("License Key")}</Label> */}
                                                        <div className="position-relative">
                                                            <IoMdKey className="position-absolute" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize: "x-large" }} />
                                                            {/* <i className="fa fa-envelope-o position-absolute" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize: "large" }}></i> */}
                                                            <Input
                                                                className="form-control pl-5"
                                                                type="text"
                                                                placeholder={t("Enter License Key")}
                                                                onChange={e => setToken(e.target.value)}
                                                                value={token}
                                                                style={{ paddingLeft: '40px' }}
                                                            />
                                                        </div>
                                                        {/* {emailError && <div className="text-danger">{emailError}</div>} */}
                                                    </FormGroup>
                                                </>
                                            )}

                                            {/* <p style={{ textAlign: "end" }}><strong style={{ cursor: "pointer" }} onClick={forgotPassword}>{t("Forgot Password ?")}</strong></p> */}
                                            <div className="position-relative form-group mb-0">
                                                <Btn attrBtn={{ type: "button", color: "primary", className: "d-block w-100 login-button", onClick: handleActivate, disabled: loading }}>{loading ? t("Activating...") : t("Activate")}</Btn>
                                            </div>
                                        </Form>
                                        <p className='mt-2' style={{ textAlign: "end" }}><strong style={{ cursor: "pointer" }} onClick={logoutUser}>{t("Back to login")}</strong></p>
                                    </div>
                                </div>
                                <div className="mx-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <small className="my-3">
                                        {t("All rights reserved Copyright ©")} {new Date().getFullYear()} {t("CLINICDOTS HEALTHCARE.")}
                                    </small>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            <ToastContainer />
        </Fragment>
    );
}
